import { useMutation, useQueryClient } from '@tanstack/react-query';

import { timeoutDelay } from '@constants/timeoutDelay';

import { apiClient } from '@services/apiClient';

import type { IDeleteSettingData } from '../model/equipmentSettingsList';
import { equipmentSettingsListKey } from './useEquipmentSettingsListQuery';
import { equipmentSettingsLogListKey } from './useEquipmentSettingsLogListInfiniteQuery';

const deleteSettingsFn = (data: IDeleteSettingData) =>
  apiClient.delete(`${APP_API_URL_V2}fsd/action-item/cost-savings-settings`, { data });

export const useDeleteSettingsMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deleteSettingsFn,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [equipmentSettingsListKey()[0]] });

      setTimeout(() => {
        queryClient.invalidateQueries({ queryKey: [equipmentSettingsLogListKey()[0]] });
      }, timeoutDelay);
    },
  });
};
